import { Box } from '@mui/material';
import Tick from '../../../assets/Icons/tick';

type ProgressCircleProps = {
  size?: number;
  progress?: number;
};

export const ProgressCircle = ({
  size = 24,
  progress = 0,
}: ProgressCircleProps) => {
  const circleSize = size + 'px';

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: circleSize,
        maxWidth: circleSize,
        minHeight: circleSize,
        maxHeight: circleSize,
        backgroundColor: '#E3DDE6',
        borderRadius: '100%',
        mask:
          progress < 100
            ? 'radial-gradient(5.5px, #0000 98%, #000)'
            : undefined,
        background: `radial-gradient(closest-side, transparent 100% 100%), conic-gradient(#3293DB ${progress}%, #E3DDE6 0)`,
      }}
    >
      {progress >= 100 && <Tick width={size / 2} />}
    </Box>
  );
};
